/*
 * INFO
 * You need to import your router settings in ./index.ts so that the main router uses them.
 *
 * router.addRoutes(YourRouterConfig)
 */

import {toInt} from '@/library/math';
import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const TestingList = () => import('../views/testing/TestingList.vue');
const TestingView = () => import('../views/testing/TestingView.vue');

const meta: MetaData = {
    module: 'testing',
};

let routes: RouteRecordRaw[] = [
    {
        path: '/testing',
        redirect: {
            name: 'testing-list',
        },
    },
    {
        name: 'testing-list',
        path: '/testing/list',
        component: TestingList,
        meta,
    },
    {
        name: 'testing-view',
        path: '/testing/view/:id/:run?',
        component: TestingView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
                run: toInt(route.params.run),
            };
        },
    },
    {
        path: '/testing/:wildcard*',
        redirect: {
            name: 'testing-list',
        },
    },
];

export default routes;